<!-- OrderDetailBody.vue -->
<template>
  <div>
    <div class="common-header-wrap">
      <mt-header :title="$t('Mystery Box Details')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="order-body" v-if="order_info">
      <div class="order_state">
        <i class="iconfont" v-if="order_info.status !== 0">&#xe61b;</i>
        <i class="iconfont" v-else>&#xe61a;</i>
        <span>{{
          order_info.status == 0
            ? $t("Unopened")
            : order_info.status == 1
            ? $t("box.opened")
            : order_info.status == 2
            ? $t("Claimed")
            : order_info.status == 3
            ? $t("Recycled")
            : $t("Unknown")
        }}</span>
      </div>

      <div
        class="order_store"
        v-if="order_info.extend_store"
        @click="
          $router.push({
            name: 'HomeStoredetail',
            query: { id: order_info.extend_store.store_id },
          })
        "
      >
        <i class="store iconfont">&#xe62d;</i
        ><span>{{ order_info.extend_store.store_name }}</span
        ><i class="more iconfont">&#xe650;</i>
      </div>

      <div class="containers" v-if="order_info.box_goods">
        <img
          class="photo"
          v-bind:src="order_info.box_goods.goods_image"
        />
        <div class="right-wrapper">
          <label class="title">{{ order_info.box_goods.goods_name }}</label>
          <div class="desc-wrapper">
            <div>
              <label class="price"
                >$ {{ order_info.box_goods.goods_price }}</label
              >
              <label class="count">x{{ 1 }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="containers" v-else>
        <img
          class="photo"
          v-if="order_info.goods_info"
          v-bind:src="order_info.goods_info.goods_image_mobile[0]"
        />
        <div class="right-wrapper">
          <label class="title">{{ order_info.title }}</label>
          <div class="desc-wrapper">
            <div>
              <label class="price">$ {{ order_info.price }}</label>
              <label class="count">x{{ 1 }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="detail">
        <div class="number">
          <label v-if="order_info.order"
            >{{ $t("OrderNo") }}: {{ order_info.order_sn }}</label
          >
          <p>{{ $t("Order Date") }}: {{ order_info.create_time_text }}</p>
          <p>
            {{ $t("OrderNo") }}: {{ order_info.order_sn }}
            <span class="copy" @click="copy(order_info.order_sn)">copy</span>
          </p>
        </div>

        <div class="pay" v-if="order_info.payment_name">
          <p>{{ $t("Payment Method") }}: {{ order_info.payment_name }}</p>
        </div>
      </div>
      <div class="desc section-header section-footer">
        <div class="container">
          <label class="title">{{ $t("Total Product Amount") }}</label>
          <label class="subtitle">${{ order_info.price }}</label>
        </div>
        <!-- <div class="container">
        <label class="title">Shipping Fee</label>
        <label class="subtitle">${{ order_info.shipping_fee }}</label>
      </div> -->
        <label class="amount"
          >{{ $t("Amount Paid") }}: <span> ${{ order_info.price }}</span>
        </label>
      </div>
    </div>

    <mt-popup
      v-model="popupRefund"
      position="right"
      class="common-popup-wrapper"
    >
      <div class="common-header-wrap">
        <mt-header title="After-Sales" class="common-header">
          <mt-button
            slot="left"
            icon="back"
            @click="popupRefund = false"
          ></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <div @click="refund(1)">
          <flex-line class="menu-item" :is-link="true" :show-border="true"
            ><span class="line-name">{{ $t("Refund") }}</span></flex-line
          >
        </div>
        <div @click="refund(2)">
          <flex-line class="menu-item" :is-link="true" :show-border="true"
            ><span class="line-name">{{ $t("Return") }}</span></flex-line
          >
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";
import { getOrderInfo, getBoxInfo } from "../../../api/memberOrder";
import flexLine from "../../flexLine";
export default {
  name: "MemberOrderDetail",
  data() {
    return {
      order_info: {},
      rec_id: 0,
      popupRefund: false,
    };
  },
  components: {
    flexLine,
  },

  created: function () {
    if (this.$route.query.order_id) {
      getBoxInfo(this.$route.query.order_id)
        .then((res) => {
          this.order_info = res.result;
        })
        .catch(function (error) {
          Toast(error.message);
        });
    }
  },

  methods: {
    copy(text) {
      this.$copyText(text).then(
        (e) => {
          Toast(this.$t("succ"));
        },
        (e) => {
          Toast(this.$t("err"));
        }
      );
    },
    goRefund(refund) {
      if (refund.return_type == 1) {
        this.$router.push({
          name: "MemberRefundView",
          query: { refund_id: refund.refund_id },
        });
      } else {
        this.$router.push({
          name: "MemberReturnView",
          query: { refund_id: refund.refund_id },
        });
      }
    },
    showRefund(rec_id) {
      this.rec_id = rec_id;
      this.popupRefund = true;
    },
    refund(type) {
      this.$router.push({
        name: "MemberReturnForm",
        query: {
          type: type,
          order_id: this.order_info.order_id,
          order_goods_id: this.rec_id,
        },
      });
    },

    complaint(order_id, goods_id) {
      this.$router.push({
        name: "MemberComplaintForm",
        query: { order_id: order_id, goods_id: goods_id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.common-header-wrap .common-header {
  box-shadow: unset;
}

.common-popup-content {
  padding: 0 $pageSpace;
  box-sizing: border-box;
}

.order-body {
  overflow: auto;
  position: absolute;
  width: 100%;

  .desc {
    .container {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      background-color: #fff;
      padding: 0.25rem 0;
    }

    .title {
      width: 5rem;
      font-size: $subFontSize;
      color: #333;
      margin-left: 0.6rem;
    }

    .subtitle {
      flex: 1;
      margin-left: 1rem;
      margin-right: 0.6rem;
      color: $primaryColor;
      font-size: $subFontSize;
      text-align: right;
    }
  }
}

.order_state {
  background: $primaryColor;
  height: 3.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  i {
    color: #fff;
    font-size: 1.2rem;
    padding: 0 0.5rem;
  }

  span {
    font-size: $h2;
    color: #fff;
  }
}

.containers {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #fff;
  border-bottom: 1px solid #e8eaed;
}

.photo {
  width: 4rem;
  height: 4rem;
  margin: 0.75rem 0.5rem 0.75rem 0.75rem;
  border: 1px solid #e8eaed;
  flex-basis: 4rem;
  flex-shrink: 0;
}

.right-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 0 0.75rem 0 0;
  width: 100%;
  overflow: hidden;

  .title {
    margin-top: 0.75rem;
    color: #333;
    font-size: $subFontSize;

    overflow: hidden;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .property {
    font-size: $fontSize;
    color: #7c7f88;
    padding-top: 0.5rem;
  }

  .desc-wrapper {
    height: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 1rem;

    .price {
      color: $primaryColor;
      font-size: $h2;
      margin-left: 0;
    }

    .btn-list {
      display: flex;

      .default {
        margin: 0 0.1rem;
      }
    }

    .count {
      margin-top: 0.2rem;
      color: #7c7f88;
      font-size: $fontSize;
      margin: 0 0.5rem;
    }
  }
}

.address {
  height: 4.4rem;
  background-color: #fff;
  margin-bottom: 0.5rem;

  div {
    padding: 0.5rem 0.5rem 0;
  }

  img {
    height: 0.8rem;
  }

  span {
    color: #333;
    font-size: $h2;

    &.mobile {
      padding-left: 1rem;
    }
  }

  p {
    margin: 0.25rem 0.9rem 0.5rem 0.5rem;
    font-size: $subFontSize;
    color: #7c7f88;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

.contact {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 2.3rem;
  background-color: #fff;
  margin-top: 0.4rem;
  border-bottom: 1px solid #e8eaed;
  padding: 0 0.65rem;

  span {
    font-size: $fontSize;
    color: #333;
    padding-right: 0.3rem;
  }

  img {
    width: 0.6rem;
    height: 0.65rem;
  }
}

.detail {
  display: flex;
  flex-direction: column;
  font-size: $subFontSize;
  color: #7c7f88;
  background-color: #fff;
  margin: 0.4rem 0;
  box-sizing: border-box;

  .number {
    padding: 0.7rem 0.8rem;
    border-bottom: 1px solid #e8eaed;

    .copy {
      color: $primaryColor;
      font-size: $subFontSize;
      margin: 0 0 0 0.5rem;
      background: #fdf7f7;
      border-radius: 10px;
      font-weight: 600;
    }

    p {
      padding-top: 0.3rem;
      font-size: $subFontSize;
    }

    button {
      color: #7c7f88;
      height: 1rem;
      background-color: #fff;
      border: 1px solid #7c7f88;
      width: 2.7rem;
      height: 1rem;
      border-radius: 0.1rem;
      font-size: $subFontSize;
    }
  }

  .pay {
    border-bottom: 1px solid #e8eaed;
    padding: 0.7rem 0.8rem;
  }

  .givetime {
    padding: 0.7rem 0.8rem;
    font-size: $subFontSize;
  }

  input {
    background-color: #fff;
    border: 1px solid #7c7f88;
  }
}

.desc {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 0.6rem;
  box-sizing: border-box;
  margin-bottom: 4rem;

  .desc-item {
    flex: 1;
    margin-top: 0.5rem;
  }

  .amount {
    display: flex;
    justify-content: flex-end;
    font-size: $subFontSize;
    color: #333;
    padding-right: 0.75rem;
    border-top: 1px solid #e8eaed;
    margin-top: 0.6rem;
    height: 2.2rem;
    line-height: 2.2rem;

    span {
      font-size: $h2;
      color: $primaryColor;
    }
  }
}

.ship {
  margin-bottom: 0;
}

.order_store {
  background: #fff;
  height: 1rem;
  line-height: 1rem;
  padding: 0.5rem 0.8rem;
  border-bottom: 1px solid #f5f5f5;
}

.order_store span {
  color: #333;
  font-size: $subFontSize;
  font-weight: 600;
  float: left;
  margin: 0 0.4rem;
}

.order_store i.store {
  float: left;
}

.order_store i.more {
  float: left;
  font-size: $subFontSize;
}

.pickup-code {
  font-size: $fontSize;
  color: #fff;
}
</style>

<style lang="scss">
.mint-toast-icon {
  font-size: 1.9rem;
}

button {
  padding: 0;
}
</style>
